import React, { Component } from 'react'
import Navbar from '../components/Navbar.js'
import MainBlock from '../components/MainBlock.js'
import Helmet from 'react-helmet'
import Footer from '../components/Footer.js'
import Modal from '../components/Modal.js'
import favicon from '../assets/favicon.png'

class IndexPage extends Component {
  state = {
    modalIsOpen: false,
    modalOpenedBy: 0,
  }

  openModal = by => this.setState({ modalIsOpen: true, modalOpenedBy: by })
  closeModal = () => this.setState({ modalIsOpen: false })

  render() {
    let style = { background: '#fff' }

    return (
      <div style={style}>
        <Helmet>
          <title>Monbanquet | Animations</title>
          <meta name="description" content="Monbanquet | Animations" />
          <meta name="keywords" content="Monbanquet | Animations" />
          <link rel="icon" href={favicon} />
        </Helmet>
        <MainBlock />
        <Footer />
        <Modal
          isOpen={this.state.modalIsOpen}
          openedBy={this.state.modalOpenedBy}
          closeModal={this.closeModal}
        />
        <Navbar openModal={this.openModal} />
      </div>
    )
  }
}

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js